import React from "react";
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

function Resources() {
    return (
        <div className="detail-box">

<h3 align="center">App Breakdown</h3>

<div className="home-category">This is a collection of videos created by <a title="ImToofu YouTube Channel" href="https://www.youtube.com/channel/UCGlSUCK8Q2rNcg4kQtbPzBA" target="_blank" rel="noreferrer noopener">ImToofu</a>.</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox">
<div className="videobox">
    <LiteYouTubeEmbed 
        id="hYM2jK1Xp0c"
        title="FiGPiN App Breakdown: App Basics"
    />
    <div className="videotitle">App Basics</div>
  </div>
</li>
<li className="gallerybox">
<div className="videobox">
    <LiteYouTubeEmbed 
        id="XGxKH1ebXIY"
        title="FiGPiN App Breakdown: Stats Explained"
    />
    <div className="videotitle">Stats Explained</div>
  </div>
</li>
<li className="gallerybox">
<div className="videobox">
    <LiteYouTubeEmbed 
        id="FBZRQJpvWso"
        title="FiGPiN App Breakdown: Boosting"
    />
    <div className="videotitle">Boosting</div>
  </div>
</li>
<li className="gallerybox">
<div className="videobox">
    <LiteYouTubeEmbed 
        id="1BsZp-lb6QU"
        title="FiGPiN App Breakdown: Shelves"
    />
    <div className="videotitle">Shelves</div>
  </div>
</li>
<li className="gallerybox">
<div className="videobox">
    <LiteYouTubeEmbed 
        id="Uz9qu7uQzvc"
        title="FiGPiN App Breakdown: Verification"
    />
    <div className="videotitle">Verification</div>
  </div>
</li>
<li className="gallerybox">
<div className="videobox">
    <LiteYouTubeEmbed 
        id="vp0i3a6Ivr0"
        title="FiGPiN App Breakdown: Chases"
    />
    <div className="videotitle">Chases</div>
  </div>
</li>
<li className="gallerybox">
<div className="videobox">
    <LiteYouTubeEmbed 
        id="BCBVTNGvvJ8"
        title="FiGPiN App Breakdown: FiGPiN Ultra"
    />
    <div className="videotitle">FiGPiN Ultra</div>
  </div>
</li>
<li className="gallerybox">
<div className="videobox">
    <LiteYouTubeEmbed 
        id="Oci6RtBdWxc"
        title="FiGPiN App Breakdown: Launch"
    />
    <div className="videotitle">Launch</div>
  </div>
</li>
<li className="gallerybox">
<div className="videobox">
    <LiteYouTubeEmbed 
        id="nviGumBPh-0"
        title="FiGPiN App Breakdown: Snap"
    />
    <div className="videotitle">Snap</div>
  </div>
</li>

</ul>

 
</div>
    );
}

export default Resources;


